import { render, staticRenderFns } from "./Error5xx.vue?vue&type=template&id=4245e0a4"
import script from "./Error5xx.vue?vue&type=script&lang=js"
export * from "./Error5xx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports